import React, { useState, useEffect } from 'react';

// ป๊อปอัพโฆษณาชวนสมัครพันธมิตร (มุมขวาล่าง) — เด้งครั้งแรก/วันละครั้ง ไม่ต้องล็อกอินก็สมัครได้
const KEY = 'noar_affpromo_ts';
const COOLDOWN = 60 * 60 * 1000; // ล็อกอินแล้วเด้งทุก ~1 ชั่วโมง (เห็นบ่อยแต่ไม่รำคาญ)

const CSS = `
@keyframes affpromoIn { from { transform: translate(24px,-50%); opacity: 0; } to { transform: translate(0,-50%); opacity: 1; } }
.affpromo-wrap{position:fixed;right:16px;top:50%;transform:translateY(-50%);z-index:99999;width:320px;max-width:92vw;
  background:linear-gradient(160deg,#520606,#360000);border:1px solid #7a2222;border-radius:16px;
  box-shadow:0 14px 40px rgba(0,0,0,.5);color:#f6e9e9;overflow:hidden;
  font-family:'Segoe UI',Tahoma,'Noto Sans Thai',sans-serif;animation:affpromoIn .4s ease}
@media(max-width:600px){.affpromo-wrap{top:auto;bottom:16px;transform:none;animation:none}}
.affpromo-top{background:linear-gradient(135deg,#e01522,#bc0009);padding:12px 14px;display:flex;align-items:center;gap:8px}
.affpromo-top b{font-size:15px;font-weight:900;color:#fff}
.affpromo-x{margin-left:auto;cursor:pointer;color:#ffd9d9;font-size:20px;line-height:1;background:none;border:none}
.affpromo-body{padding:14px}
.affpromo-body p{margin:0 0 10px;font-size:13.5px;color:#f0d9d9;line-height:1.5}
.affpromo-body .hl{color:#ffcf47;font-weight:800}
.affpromo-btn{display:block;width:100%;text-align:center;cursor:pointer;border:none;border-radius:10px;
  padding:11px 14px;font-size:14.5px;font-weight:800;color:#fff;
  background:linear-gradient(135deg,#e01522,#bc0009);box-shadow:0 6px 16px rgba(188,0,9,.4)}
.affpromo-note{display:block;text-align:center;margin-top:8px;color:#c9a3a3;font-size:11.5px}
`;

export default function AffPromoPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const path = String(window.location.pathname || '');
    if (path.indexOf('/affiliate') === 0) return undefined; // ไม่เด้งในหน้าพอร์ทัลพันธมิตร
    let loggedIn = false;
    try { loggedIn = !!localStorage.getItem('token'); } catch (e) { /* ignore */ }
    // ยังไม่ล็อกอิน = ผลักดันให้สมัคร → เด้งทุกครั้ง; ล็อกอินแล้ว = วันละครั้ง (กันรบกวนลูกค้าเดิม)
    if (loggedIn) {
      let last = 0;
      try { last = Number(localStorage.getItem(KEY) || 0); } catch (e) { /* ignore */ }
      if (Date.now() - last < COOLDOWN) return undefined;
    }
    const t = setTimeout(() => setShow(true), 6000); // เด้งหลังเข้าเว็บ ~6 วินาที
    return () => clearTimeout(t);
  }, []);

  const remember = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ } };
  const close = () => { setShow(false); remember(); };
  const go = () => { remember(); window.location.href = '/affiliate'; };

  if (!show) return null;
  return (
    <div className="affpromo-wrap">
      <style>{CSS}</style>
      <div className="affpromo-top">
        <span style={{ fontSize: 18 }}>💰</span>
        <b>หารายได้กับ NOAR</b>
        <button className="affpromo-x" onClick={close} aria-label="close">×</button>
      </div>
      <div className="affpromo-body">
        <p>สนใจสมัคร<span className="hl">พันธมิตร</span>ไหม? แนะนำเพื่อนรับ<span className="hl">ค่าคอมสูงสุด 50%</span> จ่ายจริงทุกสัปดาห์</p>
        <button className="affpromo-btn" onClick={go}>สมัครฟรี ไม่ต้องลงทุน →</button>
        <span className="affpromo-note">สมัครได้เลย ไม่ต้องเข้าสู่ระบบ</span>
      </div>
    </div>
  );
}
